import { pageableApi } from '../../config/global';
import { getStateLocalStorage, setStateLocalStorage } from '../../config/localStorage';
import { consultaCertidoesAtivas } from '../../service/ConsultarCertidoesAtivas'

const INITIAL_STATE = {
  filter: consultaCertidoesAtivas,
  pagina: 0,
  row: 10,
  isInitial: true
};

function filterConsultaCertidaoAtivasReducer(state = INITIAL_STATE, action) {

  if (action.type === 'SETFILTER_CONSULTA_CERTIDAO_ATIVA') {

    let filterConsultaCertidaoAtiva = INITIAL_STATE
    if (action.value) {
      filterConsultaCertidaoAtiva = action.value
      filterConsultaCertidaoAtiva.isInitial = false
    }

    setStateLocalStorage(filterConsultaCertidaoAtiva, 'filterConsultaCertidaoAtiva')
    return {
      ...filterConsultaCertidaoAtiva,
    }

  }

  if (state.isInitial) {
    let stateDados = getStateLocalStorage('filterConsultaCertidaoAtiva')
    if (stateDados) return stateDados
  }

  return state
}


export default filterConsultaCertidaoAtivasReducer;